// extracted by mini-css-extract-plugin
export default {"body":"CatalogPage_body__EXdJx","left":"CatalogPage_left__fCCEE"};